import { render } from "react-dom";
import dayjs from 'dayjs';
import { Trans } from "react-i18next";
import { Modal ,Descriptions,Collapse, Typography} from "antd";
import * as json from "Common/Json";
import WrapperComponent from "Components/Wrapper";
import Toast from "Components/Toast";
import { historyState } from "../store/slice/history-slice";
import { setPatientConsultationTab } from "store/slice/consultation-slice";
import configureStore from "../store";
import { Close } from "Common/ReactIcons";
import utc from 'dayjs/plugin/utc';
import { NOTIFICATION_TYPES, TS_STYLD_COMPS } from "Common/constant";
import Icons from "Common/Icons";
import PromptModal from "Components/PromptModal";
import { CONSTANTS } from "./constant";

const { store } = configureStore();
const { Panel } = Collapse;
const tabList = [
  {
    key: 'tab1',
    tab: 'A',
  },
  {
    key: 'tab2',
    tab: 'S',
  },
  {
    key: 'tab3',
    tab: 'E',
  },
  {
    key: 'tab4',
    tab: 'P',
  },
  {
    key: 'tab5',
    tab: 'T',
  },
  {
    key: 'tab6',
    tab: 'I',
  },
  {
    key: 'tab7',
    tab: 'C',
  },
]
const contentList = {
  tab1:<p>iibib</p>,
  tab2:<p>iijjbibib</p>,
  tab3:<p>iddibib</p>,
  tab4: <p>iqibib</p>,
  tab5:<p>iibqib</p> ,
  tab6:<p>iqibib</p>,
  tab7: <p>iiqbib</p>,
}
let modal, eventController, toastToggle = true, modalConfig = {};
let activeKey="tab1"
class Utils {
  renderTabContent=(val)=>{
// console.log(val)
  }
  IsObject(obj) {
    return typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
  }

  IsPageReload() {
    return (
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("reload")
    );
  }

  IsBackForwardClick() {
    return (
      (window.performance.navigation &&
        window.performance.navigation.type === 1) ||
      window.performance
        .getEntriesByType("navigation")
        .map((nav) => nav.type)
        .includes("back_forward")
    );
  }
  IsFunctionalComponent(component) {
    return (
      typeof component === "function" &&
      String(component).includes("return React.createElement")
    );
  }

  IsClassComponent(component) {
    return (
      typeof component === "function" && !!component.prototype.isReactComponent
    );
  }
  getOffSetInMinute(){
    dayjs.extend(utc)
    const now = dayjs();
    // Get the UTC offset in minutes
    const offsetInMinutes = now.utcOffset();
    return offsetInMinutes;
  }
  assessmentScoreLabel(label,type=""){
    if(type=="women"){
    return `${label} Score`
    }
    else{
      return label
    }
  }
  convertToTime(number) {
    const hours = Math.abs(Math.floor(number / 60));
    const minutes = Math.abs(number % 60);      
    // Format the time as "hh:mm"
    const formattedTime = ` GMT${number < 0 ? '-' : '+'}${hours}:${minutes.toString().padStart(2, '0')} `;      
    return formattedTime;
  }
  spreadNestedObjects(obj, keysToSpread) {
    // Create a shallow copy of the original object excluding keysToSpread
    const baseObj = { ...obj };
    keysToSpread.forEach(key => delete baseObj[key]);
  
    // Spread the nested objects into the base object
    return {
      ...baseObj,
      ...keysToSpread.reduce((acc, key) => ({ ...acc, ...obj[key] }), {})
    };
  }
  FormatDate(date, format = "DATE_TIME_1", startof) {
    if (date) {
      // console.log(date,"FIANL DATE INDEX__11")
      let finalDate = typeof data == "object" ? data : dayjs(date);
      // console.log(finalDate,"FIANL DATE INDEX")
      if (startof) finalDate.isValid() && finalDate.startOf(startof).format(json.formats[format]) || date;
      return finalDate.isValid() && finalDate.format(json.formats[format]) || date;
    } else date;
  }

  TimezoneOffsetConversion(){
    dayjs.extend(utc)
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let resultDate =  dayjs.utc().add(loginReducer.user_details.time_zone_offset_in_min, 'minute')
    return(resultDate)
  }
  TimezoneOffsetConversionForPatient(time_zone_offset_in_min){
    dayjs.extend(utc)
    let resultDate =  dayjs.utc().add(time_zone_offset_in_min, 'minute')
    return(resultDate)
  }
  ConvertLocalTimeToUserOffset(time, offset){
    dayjs.extend(utc)
    let resultDate =  dayjs.utc(time).add(offset, 'minute')
    return(resultDate)
  }
  FormFocus(form, fields) {
    eventController = new AbortController();
    window.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && form.current && Array.isArray(fields)) {
        let formObj = form.current.getFieldsValue();
        let fieldsArray = fields || [];
        for (let i = 0; i < fieldsArray.length; i++) {
          if (!formObj[fieldsArray[i]]) {
            form.current.getFieldInstance(fieldsArray[i]).focus();
            break;
          }
        }
        event.preventDefault();
      }
    }, { signal: eventController.signal });
  }

  ConvertToUnderscores(str) {
    let frags = str?.split(' ');
    for (let i=0; i<frags?.length; i++) {
      frags[i] = frags[i]?.charAt(0)?.toLowerCase() + frags[i]?.slice(1);
    }
    return frags.join('_');
  }

  ConvertToPascalCase(str) {
    if(!str) return "";
    let frags = str.split('_');
    for (let i=0; i<frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(' ');
  }

  ConvertSpaceToPascalCase(str) {
    if(!str) return "";
    let frags = str.split(' ');
    for (let i=0; i<frags.length; i++) {
      frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
    }
    return frags.join(' ');
  }

  ConvertToKebabCase(str) {
    let frags = str.split('_');
    for (let i=0; i<frags.length; i++) {
      frags[i] = frags[i].charAt(0).toLowerCase() + frags[i].slice(1);
    }
    return frags.join('-');
  }
  
  RemoveListener() {
    eventController.abort()
  }

  Sort(data, orderBy, sortBy, isDate) {
    if (Array.isArray(data)) {
      let order = orderBy == "asc" ? -1 : 1
      return data.sort((a, b) => {
        let first = typeof a == "object" && typeof sortBy == "string" ? a[sortBy] : a,
          second = typeof b == "object" && typeof sortBy == "string" ? b[sortBy] : b;
        if(isDate) {
          if(dayjs(first).isAfter(second)) return 1 * order;
          if(dayjs(second).isAfter(first)) return -1 * order;
        }
        else {
          if (first < second) return 1 * order;
          if (first > second) return -1 * order;
        }
        return 0;
      });
    }

    return data;
  }

  Toast(props) {
    toastToggle = !toastToggle
    render(<Toast {...props} show={toastToggle} />, document.getElementById("toast-container"));
  }

  Render(component, data, options) {
    let Wrapper = WrapperComponent(component, data, options);
    return <Wrapper />
  }

  Modal(open, customProps) {
    let { title, content, bodyStyle, width, onClose, closable = true } = this.IsObject(customProps)&&  customProps || {};
    if (open == true) {
      modalConfig = {
        ...modalConfig,
        callback: onClose,
      }
      modal = Modal.success({
        title: title || null,
        closable: closable,
        closeIcon: closable ? <Close /> : null,
        afterClose: () => {
          typeof modalConfig.callback == "function" && modalConfig.callback(modalConfig.data);
          modalConfig = {};
        },
        icon: null,
        centered: true,
        width: width || "300px",
        okButtonProps: {
          style: {
            display: "none",
          },
        },
        content: (
          <div style={bodyStyle || { height: "100%", overflow: "auto" }}>
            {content || null}
          </div>
        ),
      });
    }

    if (!open && modal) {
      modalConfig = {
        ...modalConfig,
        data: customProps,
      }
      modal.destroy();
    }
  }

  Capitalize(string) {
    return string && string.charAt(0).toUpperCase() + string.slice(1);
  }

  getDisplayName(firstName, lastName="") {
    return firstName + " " + lastName;
  }
  recommendedDoctorsList(arr1, arr2) {
    // Create a new array to hold the updated elements
    let updatedArr2 = [];

    // Add elements with doctor_id 2, 4, 6 from arr2 to updatedArr2
    arr1.forEach(element => {
      const found = arr2.find(obj => obj.doctor_id === element.doctor_id);
      if (found) {
        found.recommended = true;
        updatedArr2.push(found);
      }
    });

    // Add remaining elements from arr2 to updatedArr2
    arr2.forEach(element => {
      if (!arr1.find(obj => obj.doctor_id === element.doctor_id)) {
        element.recommended = false;
        updatedArr2.push(element);
      }
    });

    return updatedArr2;
  }

  LineSplit(datas) {
    return typeof datas == "string" ? datas?.split("\n").map((item, a)=> {
        return (
        <>
        {item}
        <br /> 
        </>) 
        }) : ""
 }
 LineSplitNew(datas){
  return typeof datas == "string" ? datas?.split("\n").map((item, a)=> {
    return (
    <div>
      {item}
    </div>) 
    }) : ""
 }
  salutationPrefix(salutation,name){
    return(<div style={{ padding: "0px 14px", fontWeight: 500, borderRadius: "20px" }} >
        {salutation ? salutation+". "+name : name}
    </div>)
  }

  salutationPrefixName(salutation,name){
    return salutation ? salutation+". "+name : name
  }

  FormatName(name, isDoctor) {
    let splitArray = name?.split(" ") || [], finalArray = [];
    splitArray.forEach((m) => {
      if (m && m.length && typeof m == "string") {
        finalArray.push(this.Capitalize(m.trim()));
      }
    });

    if (isDoctor) {
      return `${finalArray.join(" ")}`;
    }

    return finalArray.join(" ");
  }

  Typography(text){
    return(
        <Typography>
          <Typography.Text ellipsis={{tooltip: this.Capitalize(text)}} >
            {this.Capitalize(text)}
          </Typography.Text>
        </Typography>
    )
  }

  FirstNameLastName(text, width, emptyTooltip){
    return(
        <Typography>
          <Typography.Text style={{maxWidth: width}} ellipsis={{tooltip: emptyTooltip ? "" : text}} >
            {text}
          </Typography.Text>
        </Typography>
    )
  }

  FirstNameLastNameLink(text, width){
    return(
        <Typography>
          <Typography.Text style={{maxWidth: width}} ellipsis={{tooltip: text}}>
            <Typography.Link>
              {text}
            </Typography.Link>
          </Typography.Text>
        </Typography>
    )
  }

  PercentageCalculation(answered, totalQuestion){
    let PercentageComplete = (answered/totalQuestion) * 100
    return PercentageComplete.toFixed()
  }

  ReturnPlanIfNot(planName)
  {
    if(planName.toLowerCase().includes("plan"))
    {
      return this.ConvertToPascalCase(planName)
    }else{
      let result = planName+" Plan"
      return this.ConvertToPascalCase(result)
    }
  }
  formatAmount(amount){
    return amount.toLocaleString('en-IN', {
      // style: 'currency',
      // currency: 'INR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  }

  SetHistoryData(payload) {
    store.dispatch(historyState(payload));
  }

  formatAmount(amount, min = 0){
    return amount.toLocaleString('en-IN', {
      // style: 'currency',
      // currency: 'INR',
      minimumFractionDigits: min,
      maximumFractionDigits: 2,
    });
  }
  
  GetHistoryData() {
    let defaultStore = store.getState();
    return defaultStore.historyReducer?.history_state;
  }
RenderTabData(data){
  return(
    <div>
      <p>lln</p>
    </div>
  )
}
  RestrictNegativeNumbers(e){
    e.nativeEvent.key =='-' || e.nativeEvent.key =='+' || e.nativeEvent.key=='e'?e.preventDefault():null
  }
  RecursiveSummary(value)
  {
    return(
      Object.entries(value || {}).map(([FormItemKey, FormItemData]) => 

      {
          
              if(FormItemData.title){ 
              return(
                  this.RecursiveSummary(FormItemData.values))
              }   
              else if(Array.isArray(FormItemData.values)&&FormItemData.label)
              {
                  return(
                      <div>
                            {FormItemData.values.map((selected)=>{
                              return( selected.is_selected?
                                  <>
                                  <Descriptions
                                   bordered
                                   size="middle"
                                   contentStyle={{width:"40%"}}
                                   labelStyle={{width:"50%"}}>
                                  <Descriptions.Item label={FormItemData.label}>{selected.label}</Descriptions.Item>
                                  </Descriptions>
                                  </>:null)
                          })}
                      </div>
                      
                  )
              }  
              else
              {
                return(this.RecursiveSummary(FormItemData))                
              }   
      })
      )
  }
  onTab1Change=(val,data)=>{
  activeKey=val
  return(
this.renderTabContent(val)
  )
      }
  
  splitQuestion=(question,language)=>{
      let primLangTxt="";
      let prefLangTxt="";
   if(question.includes("/n"))
   {
     prefLangTxt=question.split("/n")[0];
     primLangTxt=question.split("/n")[1];
   } else {primLangTxt=question;}
   return(
    <>{prefLangTxt ?<> <span className={language+"-txt"}>
    {`${prefLangTxt}`}</span><br/></>:null} 
   <span className="en-txt"> {`${primLangTxt}`}</span>
   </>
   )
  }

  clinicianToBeAssigned(status = ""){
    let result =  CONSTANTS.CLINICIAN_TO_BE_ASSIGNED;
    if(status == "cancelled" || status == "missed"){
      result = CONSTANTS.CLINICIAN_UNASSIGNED;
    }
    return result;
  }

  mergeAndModifyAppointmentData(appointmentData) {
    return  {
      ...appointmentData.appointment,
      ...appointmentData.clinician,
      doctor_name : appointmentData.clinician.clinician_first_name,
      doctor_last_name : appointmentData.clinician.clinician_last_name,
    }
  }

  getCTACardIcon = (notif_type) => {
    const task_icons = {
      [NOTIFICATION_TYPES.take_assessment]: Icons.task_assessment_icon,
      [NOTIFICATION_TYPES.checkout]: Icons.task_appointment_confirmed_icon,
      [NOTIFICATION_TYPES.health_record]: Icons.task_health_info_icon,
      [NOTIFICATION_TYPES.care_plan]: Icons.task_care_plan_icon,
      [NOTIFICATION_TYPES.care_team]: Icons.task_care_team_icon,
      [NOTIFICATION_TYPES.book_appointment]: Icons.task_book_appointment_icon,
      [NOTIFICATION_TYPES.upcoming_appointment]: Icons.task_appointment_confirmed_icon,
      [NOTIFICATION_TYPES.request_appointment]: Icons.task_book_appointment_icon,
      [NOTIFICATION_TYPES.cancelled_appointment]: Icons.task_appointment_confirmed_icon,
      [NOTIFICATION_TYPES.missed_appointment]: Icons.task_appointment_confirmed_icon,
      [NOTIFICATION_TYPES.rescheduled_appointment]: Icons.task_appointment_confirmed_icon,
      [NOTIFICATION_TYPES.active_appointment]: Icons.task_active_appointment_icon,
      [NOTIFICATION_TYPES.prescription_report]: Icons.task_prescription_report_icon,
      [NOTIFICATION_TYPES.psychological_report]: Icons.task_prescription_report_icon,
      [NOTIFICATION_TYPES.psychiatry_report]: Icons.task_prescription_report_icon,
      [NOTIFICATION_TYPES.general_case_sheet_report]: Icons.task_prescription_report_icon,
      [NOTIFICATION_TYPES.payment_reminder]: Icons.task_payment_reminder_icon,
    }
    return task_icons[notif_type];
  }

  getTaskFunction = (notif_type, history, dispatch) => {
    const task_actions = {
      [NOTIFICATION_TYPES.take_assessment]: () => {
        history.push({
          pathname: "/logged-in-user/assessment",
        });
      },
      //  [NOTIFICATION_TYPES.checkout]: () => {
      //   history.push({
      //     pathname: "/logged-in-user/coupon-apply",
      //   });
      // },
      [NOTIFICATION_TYPES.health_record]: () => {
        history.push({
          pathname: "/logged-in-user/health-profile",
        });
      },
      [NOTIFICATION_TYPES.care_plan]: () => {
        history.push({
          pathname: "/logged-in-user/subscription-plan",
        });
      },
      [NOTIFICATION_TYPES.care_team]: () => {
        history.push({
          pathname: "/logged-in-user/preferred-clinician",
        });
      },
      [NOTIFICATION_TYPES.request_appointment]: () => {
        history.push({
          pathname: "/logged-in-user/consultation-history",
        });
      },
      [NOTIFICATION_TYPES.book_appointment]: () => {
        history.push({
          pathname: "/logged-in-user/consultation-history",
        });
      },
      [NOTIFICATION_TYPES.upcoming_appointment]: () => {
        dispatch(setPatientConsultationTab("upcoming"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
        });
      },
      [NOTIFICATION_TYPES.active_appointment]: () => {
        //Logic
      },
      [NOTIFICATION_TYPES.missed_appointment]: () => {
        dispatch(setPatientConsultationTab("past"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
        });
      },
      [NOTIFICATION_TYPES.cancelled_appointment]: () => {
        dispatch(setPatientConsultationTab("upcoming"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
        });
      },
      [NOTIFICATION_TYPES.rescheduled_appointment]: () => {
        dispatch(setPatientConsultationTab("upcoming"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
        });
      },
      [NOTIFICATION_TYPES.prescription_report]: () => {
        dispatch(setPatientConsultationTab("past"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
          state: { notif_type: "prescription_report" },
        });
      },
      [NOTIFICATION_TYPES.psychological_report]: () => {
        dispatch(setPatientConsultationTab("past"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
          state: { notif_type: "psychological_report" },
        });
      },
      [NOTIFICATION_TYPES.psychiatry_report]: () => {
        dispatch(setPatientConsultationTab("past"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
          state: { notif_type: "psychiatry_report" },
        });
      },
      [NOTIFICATION_TYPES.general_case_sheet_report]: () => {
        dispatch(setPatientConsultationTab("past"));
        history.push({
          pathname: "/logged-in-user/consultation-history",
          state: { notif_type: "general_case_sheet_report" },
        });
      },
      [NOTIFICATION_TYPES.payment_reminder]: () => {
        history.push({
          pathname: "/logged-in-user/subscription-plan",
        });
      },
    };
    return task_actions[notif_type];
  }
  
  getTimeZoneStrs = (existTZ, changedTZ) => {
    const existTZHour = Math.floor(Math.abs(existTZ) / 60);
    const existTZMinute = Math.abs(existTZ) % 60;
    const existTZStr =
      (existTZ < 0 ? "-" : "+") +
      existTZHour.toString().padStart(2, "0") +
      ":" +
      existTZMinute.toString().padStart(2, "0");

    const changedTZHour = Math.floor(Math.abs(changedTZ) / 60);
    const changedTZMinute = Math.abs(changedTZ) % 60;
    const changedTZStr =
      (changedTZ < 0 ? "-" : "+") +
      changedTZHour.toString().padStart(2, "0") +
      ":" +
      changedTZMinute.toString().padStart(2, "0");
    return { existTZStr, changedTZStr };
  }

  checkAllKeys(array, key) {
    return array.every(item => Boolean(item[key]));
  }
  checkAnyKey(array, key) {
  return array.some(item => Boolean(item[key]));
  }
  processedPlan(array=[]){
  let is_plan_expired=this.checkAllKeys(array,"is_plan_expired");
  let is_plan_active=this.checkAnyKey(array,"is_plan_active");
  return {is_plan_active,is_plan_expired,plan_name:true,plan_key:true};
  }
  mergeProperties(obj) {
    return Object.keys(obj).reduce((acc, key) => {
      if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
        // If the property is an object, merge its properties directly
        return { ...acc, ...obj[key] };
      } else {
        // If the property is not an object or is an array, merge it as is
        return { ...acc, [key]: obj[key] };
      }
    }, {});
  }
  getActivePlans(plans) {
    // Filter plans where is_plan_active is True
    const activePlans = plans.filter(plan => plan.plan_details.is_plan_active);

    // If no active plans, return the first plan
    if (activePlans.length === 0) {
        return [plans[0]];
    }

    return activePlans;
  } 

  /**
   * Session counts come from the API as a negative number when the plan does
   * not fix how many sessions are available - those read as "On demand". Any of
   * the given counts being negative marks the session as on demand, because the
   * pending count of an on demand session is sent as 0 and only the total
   * carries the -1.
   */
  isOnDemandSession(...counts) {
    return counts.some((count) => Number(count) < 0);
  }

  /**
   * t() wrapped in <Trans> so the multi language styling spans are applied -
   * pass styled=false where the caller needs plain text.
   */
  TransLabel(key, t, lng, styled = true) {
    const text = t(key, { lng });
    return styled ? <Trans components={TS_STYLD_COMPS}>{text}</Trans> : text;
  }

  /**
   * Shared "<count> sessions" / "<count> Reports" / "On demand" text used by the
   * care plan and subscription screens.
   * @param {object} props
   * @param {number} props.count - the count to show, number_of_sessions or number_of_sessions_pending
   * @param {number} props.total - number_of_sessions, pass it when count is the pending one
   * @param {string} props.session_type - session_type of the plan session
   * @param {function} props.t - t of the calling component
   * @param {string} props.lng - target language, pass the styled one when styled
   * @param {boolean} props.styled - wrap the label in <Trans> for the styled langs
   * @param {string} props.separator - text between the count and the label
   */
  SessionCount({ count, total = count, session_type, t, lng, styled = true, separator = " " }) {
    const label = (key) => this.TransLabel(key, t, lng, styled);

    if (this.isOnDemandSession(total, count)) {
      return <>{label(CONSTANTS.ON_DEMAND)}</>;
    }

    const isReport = session_type == "assessment_report";
    const isPlural = count > 1;
    const labelKey = isReport
      ? (isPlural ? CONSTANTS.REPORTS : CONSTANTS.ONE_REPORT)
      : (isPlural ? CONSTANTS.SESSIONS_LOWER : CONSTANTS.SESSION);

    return (
      <>
        {count}
        {separator}
        {label(labelKey)}
      </>
    );
  }

  /**
   * "<completed> of <max> sessions completed" - on demand plans have no fixed
   * number of sessions to reach, so the "of <max>" part is dropped for them.
   * @param {object} props
   * @param {number} props.completed - number_of_sessions_completed
   * @param {number} props.max - max_number_of_sessions
   * @param {function} props.t - t of the calling component
   * @param {string} props.lng - target language, pass the styled one when styled
   * @param {boolean} props.styled - wrap the labels in <Trans> for the styled langs
   */
  SessionsCompleted({ completed, max, t, lng, styled = true }) {
    const label = (key) => this.TransLabel(key, t, lng, styled);

    if (this.isOnDemandSession(max)) {
      return (
        <>
          {completed} {label(CONSTANTS.SESSION_COMPLETED)}
        </>
      );
    }

    return (
      <>
        {completed} {label(CONSTANTS.OF)} {max}{" "}
        {label(CONSTANTS.SESSION_COMPLETED)}
      </>
    );
  }

  /**
   * Plain text "<completed> of <total> sessions completed" for the places that
   * need a string instead of markup - the "of <total>" is dropped for on demand
   * plans, the same way SessionsCompleted does it.
   */
  sessionsCompletedText(completed, total) {
    return this.isOnDemandSession(total)
      ? `${completed} ${CONSTANTS.SESSION_COMPLETED}`
      : `${completed} ${CONSTANTS.OF} ${total} ${CONSTANTS.SESSION_COMPLETED}`;
  }

  getLatestPlan(data=[]) {
    if(data.length==0){
      return {
        "is_plan_active": false,
        "is_plan_expired": false,
        "plan_expiry_date": "",
        "plan_expiry_type": "",
        "plan_name": "",
        "plan_key": "",
        "is_care_team_ticket_created": false,
        "is_care_team_assigned": false,
    }
    }
    else{
      return data.find((plan) => (plan.is_plan_active ||plan.is_membership_active) && !plan.is_care_team_ticket_created) || data[0];
    // return data.sort((a, b) => new Date(b.membership_expiry_date) - new Date(a.membership_expiry_date)).find((plan) => !plan.is_membership_expired && !plan.is_care_team_ticket_created) || data[0];
  }
  }
  openTZPromptModal = (tzStrs, onAccept, onReject) => {
   this.Modal(true, {
        content: (
            <PromptModal
                title={CONSTANTS.CHANGE_TIME_ZONE}
                content={<div className="ctz-content"><div className="ctz-tz-txt">{CONSTANTS.PREF_TIME_ZONE}</div> <div className="ctz-offset-txt">UTC{tzStrs.existTZStr}</div></div>}
                subContent={<div className="ctz-sub-content"><div className="ctz-tz-txt">{CONSTANTS.CUR_TIME_ZONE}</div><div className="ctz-offset-txt">UTC{tzStrs.changedTZStr}</div></div>}
                subContent3={<div className="ctz-sub-content3"><div>{CONSTANTS.SWITCH_TIME_ZONE}</div></div>}
                acptBtnLbl={CONSTANTS.YES}
                rejtBtnLbl={CONSTANTS.NO}
                // loading={loading}
                rejtBtnType="link"
                rejtBtnClsName="link-button-green"
                onAccept={onAccept}
                onReject={onReject}
                direction="vertical"
            />
        ),
        width: "500px",
    });
}
transformOrderDetails(input){
  const{payment_details,order_details,subscription_id}=input;
  return {
    subscription_id:order_details.order_id,
    payment_mode:payment_details?.payment_mode||"online_payment",    
order_data:{...order_details,payment_categories :payment_details?.payment_methods||[
  "card",
  "nb",
  "upi"
]}
  }
}
currencyCodeToSymbol(code) {
  // Mapping of common currency codes to their symbols
  const currencySymbols = {
      USD: '$',  // US Dollar
      EUR: '€',  // Euro
      JPY: '¥',  // Japanese Yen
      GBP: '£',  // British Pound Sterling
      AUD: 'AU$', // Australian Dollar
      CAD: 'CA$', // Canadian Dollar
      INR: 'AED',  // Indian Rupee
      CHF: 'CHF', // Swiss Franc (no universal symbol)
      RUB: '₽',  // Russian Ruble
      CNY: '¥',  // Chinese Yuan (same as Japanese Yen symbol)
      NZD: 'NZ$', // New Zealand Dollar
      MXN: 'Mex$', // Mexican Peso
      BRL: 'R$',  // Brazilian Real
      ZAR: 'R',   // South African Rand
      SEK: 'kr',  // Swedish Krona
      NOK: 'kr',  // Norwegian Krone
      DKK: 'kr',  // Danish Krone
      HKD: 'HK$', // Hong Kong Dollar
      SGD: 'S$',  // Singapore Dollar
      KRW: '₩',   // South Korean Won
      TRY: '₺',   // Turkish Lira
      THB: '฿',   // Thai Baht
      VND: '₫',  // Vietnamese Dong
      IDR: 'Rp',  // Indonesian Rupiah
      PHP: '₱',   // Philippine Peso
      TWD: 'NT$', // Taiwanese Dollar
      PLN: 'zł',  // Polish Zloty
      HUF: 'Ft',  // Hungarian Forint
      CZK: 'Kč',  // Czech Koruna
      RON: 'lei', // Romanian Leu
      HRK: 'kn',  // Croatian Kuna
      ISK: 'kr',  // Icelandic Króna
      ILS: '₪',   // Israeli Shekel
      AED: 'د.إ', // United Arab Emirates Dirham
      SAR: 'ر.س', // Saudi Riyal
      QAR: 'ر.ق', // Qatari Riyal
      KWD: 'د.ك', // Kuwaiti Dinar
      OMR: 'ر.ع.',// Omani Rial
      BHD: 'د.ب', // Bahraini Dinar
      JOD: 'د.أ', // Jordanian Dinar
      LYD: 'ل.د', // Libyan Dinar
      EGP: 'ج.م', // Egyptian Pound
      NGN: '₦',   // Nigerian Naira
      ZMW: 'ZMW', // Zambian Kwacha (no universal symbol)
      TZS: 'TSh', // Tanzanian Shilling
      UGX: 'USh', // Ugandan Shilling
      XOF: 'CFA', // West African CFA Franc
      XAF: 'CFA', // Central African CFA Franc
      XPF: '₣',   // CFP Franc
      XCD: 'EC$', // East Caribbean Dollar
      KYD: 'KY$', // Cayman Islands Dollar
      JMD: 'J$',  // Jamaican Dollar
      BBD: 'Bds$',// Barbados Dollar
      TTD: 'TT$', // Trinidad and Tobago Dollar
      SRD: 'SRD', // Surinamese Dollar
      ARS: 'ARS', // Argentine Peso (no universal symbol)
      CLP: 'CLP', // Chilean Peso (no universal symbol)
      COP: 'COL$',// Colombian Peso
      PEN: 'S/.' ,// Peruvian Sol
      PYG: '₲',   // Paraguayan Guaraní
      BOB: 'Bs.', // Bolivian Boliviano
      UYU: 'UYU', // Uruguayan Peso (no universal symbol)
      VEF: 'Bs.', // Venezuelan Bolívar Soberano
      GTQ: 'Q',   // Guatemalan Quetzal
      HNL: 'L',   // Honduran Lempira
      NIO: 'C$',  // Nicaraguan Córdoba
      CRC: '₡',   // Costa Rican Colón
      DOP: 'RD$', // Dominican Peso
      PAB: 'B/.', // Panamanian Balboa
      SVC: '₡',   // Salvadoran Colón
      XDR: 'SDR', // Special Drawing Rights
      
  };

  // Return the symbol if it exists; otherwise, return the code itself
  return currencySymbols[code] || code;
}
}

export default new Utils();
